import { Phone, MessageCircle } from "lucide-react";

const WA_URL =
  "https://wa.me/905392196017?text=Merhaba%20Konya%20%C3%87ekicim,%20yolda%20kald%C4%B1m.%20Konum%20payla%C5%9Fmak%20istiyorum.";

export default function MobileBar() {
  return (
    <div
      data-testid="mobile-bottom-bar"
      className="fixed bottom-0 inset-x-0 z-50 lg:hidden border-t border-white/10 bg-night-900/95 backdrop-blur-md px-3 py-2.5 flex gap-2"
      style={{ paddingBottom: "max(0.625rem, env(safe-area-inset-bottom))" }}
    >
      <a
        href="tel:+905392196017"
        data-testid="mobile-call-button"
        className="flex-1 inline-flex items-center justify-center gap-2 bg-brand text-night-900 rounded-xl py-3.5 font-display font-bold text-xl uppercase tracking-wide active:scale-[0.98] transition-transform"
      >
        <Phone className="w-5 h-5" strokeWidth={2.5} /> Hemen Ara
      </a>
      <a
        href={WA_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-whatsapp-button"
        className="flex-1 inline-flex items-center justify-center gap-2 border border-wa/60 text-wa rounded-xl py-3.5 font-display font-semibold text-xl uppercase tracking-wide active:scale-[0.98] transition-transform"
      >
        <MessageCircle className="w-5 h-5" strokeWidth={2.5} /> Konum At
      </a>
    </div>
  );
}
